<script lang="ts">
    import { Input, Label } from "sveltestrap";
    import type { Third } from "../Model/Third";
    import { dateInputFormatter } from '../services/Functions';
    import { thirdsService } from "../services";
    import ParamSelect from "./ParamSelect.svelte";
    import UploadFile from "./UploadFile.svelte";
    import type ContextFiles from "./ContextFiles.svelte";
    import PreViewFile from "./PreViewFile.svelte";
    import PhotoUnique from "./PhotoUnique.svelte";
    import type { ThirdState } from "../global";
    import { select_value } from "svelte/internal";

    let today = dateInputFormatter(new Date);
    let contextFiles: ContextFiles;

    export let thirdData: Third | ThirdState;

    export async function saveThirdData(){
        if (!thirdData.name) return;
        await thirdsService.saveThird(thirdData)
    }

    function reloadPhoto(photoId){
        thirdData.photo = photoId;
        saveThirdData();  
    }

    function removePhoto(){
        thirdData.photo = null; 
        saveThirdData();  
    }

</script>

<style>

</style>

{#if thirdData}
    <!-- <div class="row">
        <div class="col-12 col-sm-9 mb-3">
            <div class="text-start">
                <h3>Datos de contacto</h3>
            </div>
        </div>
    </div> -->
    <div class="row">
        <div class="col-12 col-sm-2 mb-3">
            <Label for="name">Perfil</Label>
            <PhotoUnique contextId={thirdData.id} bind:photoId={thirdData.photo} on:removePhoto={(event) => removePhoto()} on:updatePhoto={(event) => reloadPhoto(event.detail)}/>
        </div>
        <div class="col-12 col-sm-10 mb-3">  
            <div class="row">
                <div class="col-12 col-sm-4 mb-3">
                    <Label for="name">Nombre</Label>
                    <Input type="text" bind:value={thirdData.name} />
                </div>
                <div class="col-12 col-sm-4 mb-3">
                    <Label for="surname1">Primer apellido</Label>
                    <Input type="text" bind:value={thirdData.surname1} />
                </div>
                <div class="col-12 col-sm-4 mb-3">
                    <Label for="surname2">Segundo apellido</Label>
                    <Input type="text" bind:value={thirdData.surname2} />
                </div>
                <div class="col-12 mb-3">
                    <Label for="alias">Alias</Label>
                    <Input type="text" bind:value={thirdData.alias} />
                </div>
                <div class="col-12 col-sm-4 mb-3">
                    <Label for="document">Doc. Identidad</Label>
                    <Input type="text" bind:value={thirdData.document} />
                </div>
                <div class="col-12 col-sm-8 mb-3">
                    <Label for="email">Email</Label>
                    <Input type="email" bind:value={thirdData.email} />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <Label for="phone1">Teléfono 1</Label>
                    <Input type="text" bind:value={thirdData.phone1} />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <Label for="phone2">Teléfono 2</Label>
                    <Input type="text" bind:value={thirdData.phone2} />
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <Label for="phone2">Género</Label>
                    <ParamSelect
                        bind:paramSelectId = {thirdData.genderId}
                        paramType = 'gender'
                        nothing = {true}
                    />
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <Label for="birthday">F. Nacimiento</Label>
                        <input class="form-control" type="date" 
                        value={dateInputFormatter(thirdData.birthday)}  
                        on:change={(event)=>thirdData.birthday = event.currentTarget.value}
                        max={today}
                    />
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <Label for="dateOfDeath">Fallecimiento</Label>
                    <input class="form-control" type="date" 
                        value={dateInputFormatter(thirdData.dateOfDeath)}  
                        on:change={(event)=>thirdData.dateOfDeath = event.currentTarget.value}
                        max={today}
                        />
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <Label for="dateOfDeath">Es abogado</Label>
                    <Input
                        type="select"
                        id="wantToDeclare"
                        value={thirdData.is_lawyer ? 1 : 0}
                        on:change={(event) => {
                        thirdData.is_lawyer = Boolean(
                            select_value(event.target)
                        );
                        }}>
                        <option value={1}>Si</option>
                        <option value={0}>No</option>
                    </Input>
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <Label for="dateOfDeath">Nº colegiado</Label>
                    <Input type="text" bind:value={thirdData.collegiate_num} />
                </div>
                <div class="col-12 mb-3">
                    <Label for="observations">Observaciones</Label>
                    <textarea class="form-control" id="observations" rows="3" bind:value={thirdData.observations}></textarea>
                </div>
            </div> 
        </div>
    </div>
{/if}



